import { Switch, withStyles } from '@material-ui/core';

const CustomSwitch = withStyles({
  root: {
    width: 40,
    height: 20,
    padding: 0,
    margin: 4,
  },
  switchBase: {
    padding: 4,
    '&$checked': {
      transform: 'translateX(20px)',
      color: '#FFFFFF',
      '& + $track': {
        backgroundColor: '#134F5C',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#134F5C',
      border: '6px solid #FFFFFF',
    },
  },
  thumb: {
    width: 12,
    height: 12,
  },
  track: {
    borderRadius: 20 / 2,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    opacity: 1,
  },
  checked: {},
  focusVisible: {},
})(Switch);

export default CustomSwitch;
